import type { BrandedIconProps } from './types';

/**
 * Asaas — Brazilian payments gateway. The brand mark is a stylized "a"
 * inside a rounded square. Brand color: `#0085FF` (Asaas blue, per the
 * official press kit at https://www.asaas.com/imprensa).
 *
 * We render a simplified, recognizable mark: a rounded square with a
 * lower-case "a" cut out so the icon stays crisp at 16/24/32 px.
 */
export function AsaasIcon({
  size = 24,
  className,
  'aria-label': ariaLabel = 'Asaas',
}: BrandedIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <rect x="2" y="2" width="20" height="20" rx="5" fill="#0085FF" />
      <path
        fill="#fff"
        d="M15.4 16.8h-1.92l-.32-1.04c-.72.8-1.68 1.2-2.88 1.2-1.12 0-2.04-.32-2.76-.96-.72-.64-1.08-1.48-1.08-2.52 0-1.16.44-2.04 1.32-2.64.88-.6 2.16-.92 3.84-.96l1.4-.04v-.32c0-.6-.16-1.04-.48-1.32-.32-.28-.84-.42-1.56-.42-.6 0-1.06.1-1.38.3-.32.2-.5.5-.54.9H7c.08-1.04.52-1.84 1.32-2.4.8-.56 1.92-.84 3.36-.84 1.4 0 2.48.32 3.24.96.76.64 1.14 1.56 1.14 2.76V16.8h.34Zm-2.4-3.4-1.32.04c-.92.04-1.6.18-2.04.42-.44.24-.66.6-.66 1.08 0 .4.14.72.42.96.28.24.66.36 1.14.36.76 0 1.36-.2 1.8-.6.44-.4.66-.94.66-1.62v-.64Z"
      />
    </svg>
  );
}
